module.exports = __webpack_public_path__ + "static/media/86.3e33066c.png";